import { Reveal, SectionHeading, Counter } from "@/components/shared";
import { IMAGES, CREA } from "@/lib/site";

const SPECIALTIES = [
  "Engenharia predial",
  "Manutenção preventiva e corretiva",
  "Recuperação e restauração",
  "Obras e reformas",
  "Gestão técnica condominial",
  "Fiscalização",
  "Diagnóstico de patologias",
  "Planejamento de investimentos",
  "Segurança e trabalho em altura",
];

const STATS = [
  { value: 17, suffix: "", label: "Especialidades técnicas" },
  { value: 6, suffix: "", label: "Etapas com garantia de qualidade" },
  { value: 100, suffix: "%", label: "Registros fotográficos das visitas" },
];

export default function About() {
  return (
    <section id="a-realiza" className="grain relative scroll-mt-20 overflow-hidden py-24 lg:py-32">
      <div className="pointer-events-none absolute -left-40 top-20 h-96 w-96 rounded-full bg-gold/5 blur-[120px]" />
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8">
        <div>
          <SectionHeading
            eyebrow="Quem é a Realiza"
            title={<>Engenharia que transforma decisões em <span className="text-gold-grad">segurança.</span></>}
          />
          <Reveal delay={0.2}>
            <p className="mt-6 leading-relaxed text-slate-400">
              A Realiza Engenharia é especializada em engenharia predial e gestão técnica
              condominial. Não vendemos reformas — entregamos diagnóstico preciso, execução
              fiscalizada e histórico técnico para que síndicos, administradoras e empresas
              decidam com segurança e invistam com inteligência.
            </p>
          </Reveal>
          <Reveal delay={0.26}>
            <div className="mt-8 flex flex-wrap gap-2.5">
              {SPECIALTIES.map((s) => (
                <span
                  key={s}
                  className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-1.5 text-xs text-slate-300 transition-colors duration-300 hover:border-gold/40 hover:text-gold"
                >
                  {s}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.32}>
            <div className="mt-12 grid grid-cols-2 gap-x-8 gap-y-10 sm:grid-cols-4">
              {STATS.map((s) => (
                <div key={s.label} className="border-l border-gold/25 pl-4">
                  <Counter to={s.value} suffix={s.suffix} className="font-display text-4xl font-extrabold text-gold" />
                  <p className="mt-1.5 text-[11px] uppercase leading-snug tracking-wider text-slate-500">{s.label}</p>
                </div>
              ))}
              <div className="border-l border-gold/25 pl-4">
                <span className="font-mono text-lg font-semibold leading-tight text-gold">{CREA}</span>
                <p className="mt-1.5 text-[11px] uppercase leading-snug tracking-wider text-slate-500">Responsável técnico</p>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="relative">
          <div className="relative ml-auto max-w-lg">
            <div className="absolute -right-4 -top-4 h-full w-full border border-gold/30" />
            <img
              src={IMAGES.aboutMain}
              alt="Profissional da Realiza Engenharia em trabalho de altura com cordas na fachada de um edifício"
              className="relative w-full object-cover"
              loading="lazy"
            />
            <div className="absolute -bottom-6 right-4 max-w-[240px] border border-gold/25 bg-navy-900/90 p-5 backdrop-blur-md">
              <p className="font-serif text-lg italic leading-snug text-gold-bright">
                "Você imagina. A gente realiza."
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
